<template>
    <div class="header">
        <img class="logo_icon" src="./images/logo.svg" alt="logo"/>
        <div class="menus">
            <Menus></Menus>
        </div>
    </div>
</template>

<script>
import Menus from "../Menus/Menus";

export default {
    name: "Header",
    components: {Menus},
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
/* 顶部样式 */
.header {
    position: absolute;
    top: 46rem;
    left: 50%;
    transform: translate(-50%, 0);
    width: 1200rem;
    height: 80rem;
    background: #FD6520;
    box-shadow: 0 4rem 20rem 0 rgba(0, 0, 0, 0.2);
    border-radius: 50rem;
    z-index: 999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 21rem;

    .logo_icon {
        width: 177rem;
    }

    .menus {
        margin: 0 38rem;
        flex: 1 1 auto;
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .header {
        transform: translate(-16%, 0);
    }
}
</style>
